import type { NotificationInbox, NotificationPreferences } from '@/types';
import { EMPTY_INBOX } from '@/types';
import { read, write } from './http';

const DEFAULT_PREFERENCES: NotificationPreferences = {
  newContests: true,
  fillingUp: true,
  playersLocked: true,
  costlyMoments: true,
  rankChanges: true,
};

/** Inbox, unread count, the action banner and the nav dots. */
export function getNotifications(signal?: AbortSignal): Promise<NotificationInbox> {
  return read('/me/notifications', () => EMPTY_INBOX, signal, { fallbackWhenEmpty: false });
}

export function markNotificationRead(id: string): Promise<NotificationInbox> {
  return write(`/me/notifications/${id}/read`, 'POST', {}, () => EMPTY_INBOX);
}

export function markAllNotificationsRead(): Promise<NotificationInbox> {
  return write('/me/notifications/read-all', 'POST', {}, () => EMPTY_INBOX);
}

export function getNotificationPreferences(
  signal?: AbortSignal,
): Promise<NotificationPreferences> {
  return read('/me/notifications/preferences', () => DEFAULT_PREFERENCES, signal, {
    fallbackWhenEmpty: false,
  });
}

export function updateNotificationPreferences(
  patch: Partial<NotificationPreferences>,
): Promise<NotificationPreferences> {
  return write('/me/notifications/preferences', 'PATCH', patch, () => ({
    ...DEFAULT_PREFERENCES,
    ...patch,
  }));
}
